import { defineRecipe } from '@chakra-ui/react/styled-system';

const badgeRecipe = defineRecipe({
  className: 'badge',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4',
    borderRadius: '4',
    textStyle: 'comp/badge/sm',
    width: 'fit-content',
    height: 'fit-content',
    verticalAlign: 'bottom',
    flexShrink: 0,
  },
  variants: {
    size: {
      xs: {
        minWidth: '20',
        paddingBlock: '2',
      },
      sm: {
        minWidth: '24',
        paddingBlock: '4',
      },
    },
    colorVariant: {
      neutral: { color: 'color/neutral/strong', background: 'color/neutral/subtle' },
      purple: { color: 'color/purple/strong', background: 'color/purple/subtle' },
      blue: { color: 'color/blue/strong', background: 'color/blue/subtle' },
      green: { color: 'color/green/strong', background: 'color/green/subtle' },
      yellow: { color: 'color/yellow/strong', background: 'color/yellow/subtle' },
      red: { color: 'color/red/strong', background: 'color/red/subtle' },
      orange: { color: 'color/orange/strong', background: 'color/orange/subtle' },
      turquoise: { color: 'color/turquoise/strong', background: 'color/turquoise/subtle' },
      'ai-gradient': { color: 'status/ai/text', background: 'gradient/ai/background/subtle' },
    },
    variant: {
      subtle: {},
      bold: {
        color: 'text/on-color',
      },
    },
  },
  compoundVariants: [
    { colorVariant: 'neutral', variant: 'bold', css: { background: 'color/neutral/bold' } },
    { colorVariant: 'purple', variant: 'bold', css: { background: 'color/purple/bold' } },
    { colorVariant: 'blue', variant: 'bold', css: { background: 'color/blue/bold' } },
    { colorVariant: 'green', variant: 'bold', css: { background: 'color/green/bold' } },
    { colorVariant: 'red', variant: 'bold', css: { background: 'color/red/bold' } },
    { colorVariant: 'orange', variant: 'bold', css: { background: 'color/orange/bold' } },
    { colorVariant: 'turquoise', variant: 'bold', css: { background: 'color/turquoise/bold' } },
    {
      colorVariant: 'ai-gradient',
      variant: 'bold',
      css: { background: 'gradient/ai/background/bold', color: 'text/on-color' },
    },
    { colorVariant: 'yellow', variant: 'bold', css: { background: 'color/yellow/muted', color: 'text/primary' } },
  ],
  defaultVariants: {
    colorVariant: 'neutral',
    variant: 'subtle',
    size: 'sm',
  },
});

export default badgeRecipe;
